import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hh-security-cameras-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './security-cameras-widget.component.html',
  styleUrls: ['./security-cameras-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityCamerasWidgetComponent {}
